import { GeneralResourceDetail } from '../ResourceDetail'

export const EQIP_PRACTICE_CHOICE_SOIL = [
  '340',
  '512',
  '528',
  '612',
  '590',
  '338',
  '329',
  '345',
  '550',
  '328',
  '595',
  '449',
  '484',
  '327',
  '412',
  '420',
  '342',
  '422',
  '460',
  '610',
  '333',
  '386',
  '390',
  '324',
  '511',
  '393',
  '330',
  '331',
  '586',
  '332',
  '326',
  'none',
]
export type EqipPracticeChoiceSoil = typeof EQIP_PRACTICE_CHOICE_SOIL[number]

export type RDEqipPracticeChoiceSoil = GeneralResourceDetail<
  EqipPracticeChoiceSoil[],
  'eqipPracticeChoiceSoil'
>
